/**
 * The embed snippet a school pastes into its site.
 *
 * The contract is `apps/widget/src/embed.tsx`: an IIFE bundle that reads
 * `data-client-id` off its own script tag, so one deployed `widget.js` serves every
 * client and the snippet differs only by that attribute.
 *
 * The URL is an env var rather than a constant so a local or preview CRM does not
 * hand out a snippet pointing at production.
 */
const WIDGET_SRC =
  (import.meta.env.VITE_WIDGET_SRC as string | undefined) ??
  "https://widget.scholaops.ai/widget.js";

export function buildWidgetSnippet(clientId: string): string {
  return `<script src="${WIDGET_SRC}" data-client-id="${clientId}" async></script>`;
}

/**
 * The optional second snippet: a CTA already on the school's site that opens the
 * chat and asks a question for the visitor.
 *
 * Unlike the embed snippet this one carries no client id — the attribute is read
 * by the already-loaded widget (`apps/widget/src/lib/host-api.ts`), so it is the
 * same markup for every client and exists purely as a copy-pasteable example.
 * `data-scholaops-entry` is optional; without it the button's own text becomes
 * the attribution label shown in the CRM.
 */
export function buildCtaExampleSnippet(): string {
  return [
    '<button',
    '  data-scholaops-prompt="Quiero agendar una demo"',
    '  data-scholaops-entry="CTA demo — home"',
    '>',
    "  Agenda una demo",
    "</button>",
  ].join("\n");
}
